<template>
  <div class="drugCategory">
    <div class="layer">
      <Search @func="getMsgFormSearch"/>
    </div>
    <div class="layer">
        <SuperNav :list="data.headerNav"/>
    </div>
    <div class="nav_bottom"></div>
    <div class="layer">
      <Bread :prop="bread" />
    </div>
    <div class="layer">
      <div class="filterWrap">
        <div class="filterItem" v-if="listData.category_id && listData.category_id.length">
          <div class="left">一级分类</div>
          <div class="right">
            <el-radio-group v-model="searchFields.category_id" @change="toPageOne($event, 'category_id')" size="mini">
              <el-radio-button v-for="(item, index) in listData.category_id" :key="index" :label="item.id">{{item.name}}</el-radio-button>
              <el-button type="primary" icon="el-icon-caret-bottom" class="slideButton" v-if="!rightSlide[0]" @click="rightUp(0)"></el-button>
            </el-radio-group>
          </div>
        </div>
        <div class="filterItem" v-if="listData.cat_id && listData.cat_id.length">
          <div class="left">二级分类</div>
          <div class="right">
            <el-radio-group v-model="searchFields.cat_id" @change="toPageOne($event, 'cat_id')"  size="mini">
              <el-radio-button v-for="(item, index) in listData.cat_id" :key="index" :label="item.id">{{item.name}}</el-radio-button>
              <el-button type="primary" icon="el-icon-caret-bottom" class="slideButton" v-if="!rightSlide[1]" @click="rightUp(1)"></el-button>
            </el-radio-group>
          </div>
        </div>
        <div class="filterItem" v-if="listData.manufacturer_id && listData.manufacturer_id.length">
          <div class="left">生产产家</div>
          <div class="right" :class="!rightOverFlow[2]?'rightOverFlow':''">
            <el-radio-group v-model="searchFields.manufacturer_id" @change="toPageOne($event, 'manufacturer_id')" size="mini">
              <el-radio-button v-for="(item, index) in listData.manufacturer_id" :key="index" :label="item.id">{{item.name}}</el-radio-button>
              <el-button type="primary" icon="el-icon-caret-bottom" class="slideButton" v-if="!rightSlide[2]" @click="rightUp(2)"></el-button>
            </el-radio-group>
          </div>
        </div>
        <div class="filterItem" v-if="listData.dosage_form && listData.dosage_form.length">
          <div class="left">剂型</div>
          <div class="right">
            <el-radio-group v-model="searchFields.dosage_form" @change="toPageOne($event, 'dosage_form')" size="mini">
              <el-radio-button v-for="(item, index) in listData.dosage_form" :key="index" :label="item.id">{{item.name}}</el-radio-button>
              <el-button type="primary" icon="el-icon-caret-bottom" class="slideButton" v-if="!rightSlide[3]" @click="rightUp(3)"></el-button>
            </el-radio-group>
          </div>
        </div>
        <div class="filterItem" v-if="listData.medicine_type && listData.medicine_type.length">
          <div class="left">处方类型</div>
          <div class="right">
            <el-radio-group v-model="searchFields.medicine_type" @change="toPageOne($event, 'medicine_type')" size="mini">
              <el-radio-button v-for="(item, index) in listData.medicine_type" :key="index" :label="item.id">{{item.name}}</el-radio-button>
              <el-button type="primary" icon="el-icon-caret-bottom" class="slideButton" v-if="!rightSlide[4]" @click="rightUp(4)"></el-button>
            </el-radio-group>
          </div>
        </div>
        <div class="filterItem" v-if="listData.healthcare_type && listData.healthcare_type.length">
          <div class="left">医保类型</div>
          <div class="right">
            <el-radio-group v-model="searchFields.healthcare_type" @change="toPageOne($event, 'healthcare_type')" size="mini">
              <el-radio-button v-for="(item, index) in listData.healthcare_type" :key="index" :label="item.id">{{item.name}}</el-radio-button>
              <el-button type="primary" icon="el-icon-caret-bottom" class="slideButton" v-if="!rightSlide[5]" @click="rightUp(5)"></el-button>
            </el-radio-group>
          </div>
        </div>
        <div class="filterItem" v-if="selectedFields && selectedFields.length">
          <div class="left">已选中</div>
          <div class="right">
            <el-tag size="medium" class="tag" v-for="(item, index) in selectedFields" :key="index" @close="cancelCondition(item)" closable>{{item.value}}</el-tag>
          </div>
        </div>
        <!--<div class="layer">
          <Banner :prop="banner" class="mt20" />
        </div>-->
      </div>
    </div>

    <div class="layer list">
      <Commdity :prop="commdity1" class="mt30 fl" />
      <div>
        <CommdityRight @change="tabChange" :sort="searchFields.order_type" class="mt30 ml15" :count="pageOption.totalRow" :prop="commdity" />
        <div class="page">
          <el-pagination
            background
            layout="prev, pager, next"
            @current-change="changePage"
            :current-page="pageOption.page"
            :page-size="pageOption.page_size"
            v-if="pageOption.totalRow>pageOption.page_size"
            :total="pageOption.totalRow">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Search from '@/components/Search/index'
import SuperNav from '@/components/SuperNav/index'
import Bread from '@/components/Bread/index'
//import Banner from '@/components/Banner/smallBanner'
import Commdity from '@/components/CommdityList/commdityLeft'
import CommdityRight from '@/components/CommdityList/commdityRight'
import { GoodsService } from '../../service/goods.service'

  export default {
    name: 'drugCategory',
    components: {
        Search,
        SuperNav,
        Bread,
//        Banner,
        Commdity,
        CommdityRight
    },
    data() {
      return{
        bread: [{
            name: '药品分类',
            path: '/drugCategory'
        }],
        banner: [{
            src: 'https://api.goodyiyao.cn/static/upload/other/smallBanner.jpg'
        }],
        commdity1: [{
          title: "热门推荐",
          commdity: []
        }],
        commdity: [],
        searchFields: {

        },
        fieldsNames: {
          category_id: '',
          cat_id: '',
          manufacturer_id: '',
          dosage_form: '',
          medicine_type: '',
          healthcare_type: ''
        },
        listData: {},
        pageOption: {
          page: 1,
          page_size: 24,
          totalRow: 0,
        },
        rightSlide:[true,true,true,true,true,true],
        rightOverFlow: [true,true,true,true,true,true],
      }
    },
    async created() {
      this.searchFields = this.$router.currentRoute.query;
      this.searchFields.order_type = 'desc';
      await this.getList();
    },
    computed: {
      selectedFields() {
        const list = [];
        for (const key of Object.keys(this.fieldsNames)) {
          this.fieldsNames[key] && list.push({key, value: this.fieldsNames[key]});
        }
        return list;
      },
      data() {
          return this.$store.getters.shop_index
      }
    },
    watch:{
      $route(){
        this.$set(this.searchFields,'category_id',this.$route.query.category_id)
        this.$set(this.searchFields,'cat_id',this.$route.query.cat_id)
        this.$set(this.searchFields,'manufacturer_id',this.$route.query.manufacturer_id)
        this.$set(this.searchFields,'dosage_form',this.$route.query.dosage_form)
        this.$set(this.searchFields,'medicine_type',this.$route.query.medicine_type)
        this.$set(this.searchFields,'healthcare_type',this.$route.query.healthcare_type)
        this.getList()
      }
    },
    methods: {
      async getList() {
        this.commdity = [];
        const data = await GoodsService.goodsList({
          ...this.searchFields,
          page: this.pageOption.page,
          page_size: this.pageOption.page_size,
        });
        this.pageOption.page = data.page;
        this.pageOption.totalRow = data.totalRow;
        this.listData = data;
        data.list.forEach(item => {
          if(item.common_name.indexOf('（')>0||item.common_name.indexOf('(')>0) {
            item.goods_name = ''
          }
          item.original_img = GoodsService.spliceImg(item.original_img)
        });
        this.listData.hotGoods.forEach(item=> {
          if(item.common_name.indexOf('（')>0||item.common_name.indexOf('(')>0) {
            item.goods_name = ''
          }
        })
        this.updateSelectedData();
        setTimeout(() => {
          this.commdity = data.list;
          this.commdity1[0].commdity = JSON.parse(JSON.stringify(this.listData.hotGoods))
        }, 120);
        this.$nextTick(function () {
          this.rightOverFlow = [true,true,true,true,true,true]
          this.changeHeight()
        })
      },
      async getMsgFormSearch() {
        this.searchFields = this.$router.currentRoute.query;
        this.searchFields.order_type = 'desc';
        console.log(this.searchFields)
        await this.getList();
      },
      changeHeight() {//判断.right收缩展开状态
        let filterItemArr = document.getElementsByClassName('filterItem')
        filterItemArr.forEach((val,index)=>{
          if(val.clientHeight>50) {
            this.rightSlide[index] = false
          }else{
            this.rightSlide[index] = true
          }
        })
      },
      rightUp(val) {//改变.right收缩展开状态
        this.$set(this.rightOverFlow,val,!this.rightOverFlow[val])
      },
      changePage(page) {
        this.pageOption.page = page;
        this.getList();
      },
      cancelCondition({ key }) {
        let url = document.location.toString()
        let arrObj = url.split("?")
        if (arrObj.length>1) {
          let arrPara = arrObj[1].split("&");
          arrPara.forEach((val,i)=>{
            if(val.split("=")[0] =={ key }.key) {
              arrPara.splice(i,1)
            }
          })
          let obj = {}
          arrPara.forEach((val)=>{
            obj[val.split("=")[0]] = val.split("=")[1]
          })
          this.$router.push({query:obj})
        }
        delete this.searchFields[key];
        this.fieldsNames[key] = '';
        this.toPageOne();
      },
      updateSelectedData() {
        this.fieldsNames = {
          category_id: '',
          cat_id: '',
          manufacturer_id: '',
          dosage_form: '',
          medicine_type: '',
          healthcare_type: ''
        };
        for (const key of Object.keys(this.fieldsNames)) {
          if (this.searchFields[key]) {
            this.fieldsNames[key] = (this.listData[key].find(item => String(item.id) === String(this.searchFields[key])) || {}).name;
          }
        }
      },
      tabChange(key) {
        if (key === 'default') {
          delete this.searchFields.order_by;
          this.searchFields.order_type = 'desc';
        } else {
          if (this.searchFields.order_by === key) {
            this.searchFields.order_type = this.searchFields.order_type === 'desc' ? 'asc' : 'desc';
          } else {
            this.searchFields.order_by = key;
          }
        }
        this.toPageOne();
      },
      toPageOne(val1,val2) {
        this.pageOption.page = 1;
        let url = document.location.toString()
        let arrPara
        let obj = {}
        if(url.indexOf("?")>0) {
          let arrObj = url.split("?")
          arrPara = arrObj[1].split("&");
           arrPara.forEach((val)=>{
            obj[val.split("=")[0]] = val.split("=")[1]
          })
          obj[val2] = val1
          this.$router.push({query:obj})
        }else{
          obj[val2] = val1
          this.$router.push({query:obj})
        }
        this.getList();
      },
    },
  }
</script>

<style lang="scss" scoped>
  .right{
    overflow: hidden;
    padding-right: 15px;
    width: auto!important;
    .slideButton{
      position: absolute;
      top: 8px;
      right: 15px;
      padding: 5px!important;
      border-radius: 5px!important;
    }
  }
  .filterWrap{
    border: 1px solid #3099d6;
    width: 1197px;
    margin-left: 1px;
    margin-top: 1px;
    padding-bottom: 1px;
    .filterItem{
      display: flex;
      flex-direction: row;
      border-bottom: 1px solid #a0c9e2;
      position: relative;
      .left{
        width: 70px;
        padding: 10px 25px;
        text-align: justify;
        background: #ddedf6;
        font-weight: 700;
        display: flex;
        align-items: center;
      }
      .left::after{
        position: absolute;
        content:':';
        left: 100px;
        display: inline-block;
      }
      .right {
        flex: 1;
        .el-radio-group {
          width: 100%;
          & /deep/ .el-radio-button {
            margin: 8px 10px 8px 20px;
            float: left;
            border-left: 1px solid #B9B9B9;
            .el-radio-button__inner {
              border-radius: 0 !important;
            }
          }
          
        }
      }
    }
    .filterItem:last-child{
      border-bottom: 0;
    }
  }
  .commdity{
    width: 216px;
    text-align: left;
    border-top: 1px solid #e3e2e1;
    border-right: 1px solid #e3e2e1;
    height: 243px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 10px 0px 10px 20px;
    transition: all .2s ease-in;
  }
  .commdity .mask{
      background: #000;
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      opacity: 0.04;
      display: none;
  }
  .commdity:hover{
      box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1)
  }
  .commdity img{
      padding-right: 20px;
      height: 100px;
  }
  .commdity .company{
      width: 180px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
  }
  .commdity:nth-child(n+5){
      border-bottom: 1px solid #e3e2e1;
  }
  .list {
    display: flex;
  }
  .page {
    display: flex;
    justify-content: flex-end;
  }
  .tag {
    margin: 8px;
  }
  .rightOverFlow{
    height: 50px;
    overflow: hidden;
  }
</style>

<style lang="scss">
  .drugCategory{
    .el-radio-button:first-child .el-radio-button__inner{
      border-left: 0;
    }
    .el-radio-button--mini .el-radio-button__inner{
      border: none;
    }
    .filterWrap .filterItem .right .el-radio-group[data-v-20f93b76] .el-radio-button{
      border-left: none;
    }
  }
</style>